import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router';
import LoadingSpinner from '../components/widgets/LoadingSpinner';

export const OnboardingRoute = () => {
  const authState = useSelector((state) => state.auth);

  if (authState.loading)
    return <LoadingSpinner />;

  //  if we're no longer signed in, then return to the home page
  if (!authState.isLoggedIn)
    return <Navigate to="/" replace />;

  return <Outlet />;
};
 